module.exports = __webpack_public_path__ + "static/media/about-eunice.4f0b7261.png";